export default {
    parts: [
        'container',
        'headerFlex',
        'titleGroup',
        'giftIcon',
        'title',
        'chevronIcon',
        'appliedCardRow',
        'cardNumberText',
        'cardValueText',
        'cardBalanceText',
        'removeButton',
        'warningBox',
        'addAnotherButton',
        'inputStack',
        'pinRow',
        'applyButton',
        'recaptchaText',
        'recaptchaLink',
        'placeOrderBox',
        'placeOrderContainer',
        'placeOrderButton'
    ],
    baseStyle: {
        container: {
            flex: '1',
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeDefault',
            pb: 3,
            mb: 12
        },
        headerFlex: {
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        titleGroup: {
            alignItems: 'center',
            gap: 2
        },
        giftIcon: {
            boxSize: 5
        },
        title: {
            textStyle: 'bodySmRegular',
            cursor: 'pointer',
        },
        chevronIcon: {
            boxSize: 6,
            transition: 'transform 0.2s ease-in-out'
        },
        appliedCardRow: {
            mt: {base: 3},
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'start',
            border: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            p: 4
        },
        cardNumberText: {
            textStyle: 'bodyXsSBold'
        },
        cardValueText: {
            textStyle: 'bodyXsSRegular'
        },
        cardBalanceText: {
            textStyle: 'bodyXsSRegular',
            color: 'webTypo.textTertiary'
        },
        removeButton: {
            textDecoration: 'underline',
            textStyle: 'bodyXsSLink',
            flexShrink: 0,
            h: 'auto',
            minH: 'auto'
        },
        warningBox: {
            textStyle: 'bodyXsRegular',
            bg: 'webTheme.supportWarning',
            color: 'supportInfo',
            p: 4,
            my: 2
        },
        addAnotherButton: {
            textStyle: 'labelXs',
            h: 'auto',
            minH: 'auto'
        },
        inputStack: {
            spacing: 2,
            mt: 3
        },
        pinRow: {
            gap: 2,
            alignItems: 'flex-start'
        },
        applyButton: {
            width: '100%',
            maxWidth: '124px',
            flexShrink: 0,
            alignSelf: 'flex-start'
        },
        recaptchaText: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textTertiary'
        },
        recaptchaLink: {
            textDecoration: 'underline',
            textStyle: 'bodyXsRegular'
        },
        placeOrderBox: {
            pt: 6,
            pb: 11,
            background: 'white'
        },
        placeOrderContainer: {
            ml: 0
        },
        placeOrderButton: {
            width: '100%',
            maxWidth: {base: 'none', lg: '331px'}
        }
    }
}
